import { api } from './api';

// Generate or get session ID
const getSessionId = () => {
  let sessionId = localStorage.getItem('sessionId');
  if (!sessionId) {
    sessionId = `session_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
    localStorage.setItem('sessionId', sessionId);
  }
  return sessionId;
};

// Track last tracked page to prevent double counting
let lastTrackedPage = null;
let lastTrackTime = 0;

// Track page view with deduplication
export const trackPageView = (pageName) => {
  const now = Date.now();
  // Prevent duplicate tracking within 1 second for same page
  if (pageName === lastTrackedPage && now - lastTrackTime < 1000) {
    return;
  }
  
  lastTrackedPage = pageName;
  lastTrackTime = now;
  
  const sessionId = getSessionId();
  api.trackPageView(pageName, sessionId);
};

export default { trackPageView };